import React, { useEffect } from "react";
import * as GC from "../../../../common/common";
import * as CommonFunctions from "../functions/commonFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import { InitiateProcessAction } from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";
import {GetSelected} from "../../../../common/tableHandler/manipulateTable";
import { CAT_JR_CONST } from "../../../../../constants/ActionEnums/CatActionEnums";

class Uitvoerder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleSubmit() {
    $("#cover-spin").show(0);

    const model = {
      action: CAT_JR_CONST.TORK_PERFORMANS,
      uitvoerder_identification: $("input[name=uitvoerder]:checked").attr("id"),
      identifications: GetSelected(),
    };

    InitiateProcessAction(model, CAT_JR_CONST.END_POINT)
      .then(() => {
        this.handleNext()
      })
      .catch(() => {
        alert("Something went wrong!");
        $("#cover-spin").hide(0);
      });

      /* omnimap.InputDataActivityFlowAction(
      window.$catalog_work_resources_actions[0].id,
      GetSelected(),
      model,
    ).then(() => 
      this.handleNext()
    ); */

    /* var model = {
      bronInstanceDefinitionCode: "WERKBRON",
      uitvoerderOfWerkbron: $("input[name=uitvoerder]:checked").attr("id"),
    };

    var selectedIds = [];
    $("#example")
      .dataTable()
      .$("tr.selected")
      .each(function () {
        selectedIds.push($(this).attr("rowId"));
      });

    GC.StartActivity(
      model,
      selectedIds,
      "3eb8eaa0-a882-427a-8af3-7707d27b587b",
      this.handleNext,
      window.$catalog_management_units_token
    );*/
  }
  handleNext() {
    GC.sleep(500).then(() => {
      $("#koppelen_aan_uitvoerder").modal("hide");
      window.$catalog_work_resources_refresh();
     /* omnimap
        .FillTableAction(
          window.$catalog_work_resources_lastUsedTableFilter,
          1,
          window.$catalog_management_units_token
        )
        .then((result) => {
          CallBackFunctions.FillTableCallBack(result, 1);
        });*/
    });
  }
  componentDidMount() {
    $("#koppelen_aan_uitvoerder").on("show.bs.modal", function (event) {
      GC.GetEntityList(
        process.env.REACT_APP_WORK_RESOURCE_UITVOERDER,
        1,
        30,
        CallBackFunctions.UitvoerderCallback,
        window.$catalog_management_units_token,
      {
              "key": "algemeen-isuitvoerder",
              "and_or": "AND",
              "values": [true],
        "datatype": "BOOLEAN"
                }

      );
    });
  }

  render() {
    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="koppelen_aan_uitvoerder"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Selecteer uitvoerder</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <input type="search" className="modal-search" placeholder="" />
              <div className="modal-scroll">
                <div id="koppelen-uitvoerder-grp" className="radio-grp" />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                id="resources_uitvoerder_save"
                className="btn-modal"
                onClick={this.handleSubmit.bind(this)}
              >
                Verwerken
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Uitvoerder;
